import { render, staticRenderFns } from "./JinNangCancle.vue?vue&type=template&id=0a18d0c4&scoped=true&"
import script from "./JinNangCancle.vue?vue&type=script&lang=js&"
export * from "./JinNangCancle.vue?vue&type=script&lang=js&"
import style0 from "./JinNangCancle.vue?vue&type=style&index=0&id=0a18d0c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a18d0c4",
  null
  
)

export default component.exports